export const GET_DOCUMENT_BANK_QUERY = `
  query GetDocumentBank {
    document_bank(order_by: { updated_at: desc }) {
      id
      company_id
      title
      description
      created_by
      created_at
      updated_at
      category
      process
      is_active
      creator {
        id
        first_name
        last_name
      }
      versions(order_by: { version_number: desc }) {
        id
        version_number
        file_url
        file_name
        file_size
        mime_type
        notes
        uploaded_by
        uploaded_at
        uploader {
          id
          first_name
          last_name
        }
      }
      assignments {
        id
        assignment_type
        assignment_ref_id
        created_by
        created_at
      }
      tag_assignments {
        id
        tag_id
        tag {
          id
          name
          color
        }
      }
    }
  }
`;

export const GET_DOCUMENT_BANK_BY_ID_QUERY = `
  query GetDocumentBankById($id: uuid!) {
    document_bank_by_pk(id: $id) {
      id
      company_id
      title
      description
      created_by
      created_at
      updated_at
      category
      process
      is_active
      versions(order_by: { version_number: desc }) {
        id
        version_number
        file_url
        file_name
        file_size
        mime_type
        notes
        uploaded_by
        uploaded_at
        uploader {
          id
          first_name
          last_name
        }
      }
      assignments {
        id
        assignment_type
        assignment_ref_id
      }
      tag_assignments {
        id
        tag_id
        tag {
          id
          name
          color
        }
      }
    }
  }
`;

export const GET_LATEST_VERSION_NUMBER_QUERY = `
  query GetLatestVersionNumber($documentId: uuid!) {
    document_bank_versions(
      where: { document_id: { _eq: $documentId } }
      order_by: { version_number: desc }
      limit: 1
    ) {
      version_number
    }
  }
`;

// useDynamicEntity pattern'ine uyumlu: `$where` filtrelemesi + `_aggregate`.
// Sirket-scoped filtre useDocumentBankTags hook'ta customWhereCondition ile
// eklenir (root disindaki roller icin).
export const GET_DOCUMENT_BANK_TAGS_QUERY = `
  query GetDocumentBankTags($where: document_bank_tags_bool_exp = {}) {
    document_bank_tags(where: $where, order_by: { name: asc }) {
      id
      name
      color
      company_id
      company {
        id
        name
      }
      created_by
      created_at
      updated_at
    }
    document_bank_tags_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_DOCUMENT_BANK_TAG_BY_ID_QUERY = `
  query GetDocumentBankTagById($id: Int!) {
    document_bank_tags_by_pk(id: $id) {
      id
      name
      color
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;
